/**
 * The Firebase web config on its own, with no side effects.
 *
 * Split out from `./firebase` because that module calls `getAuth()` at import
 * time. Anything that only needs the config — FCM messaging, diagnostics — must
 * import from here, or it drags the whole auth SDK into bundles that no longer
 * use Firebase for sign-in at all (both portals now authenticate with Better
 * Auth). These values are public by design; they ship in the client bundle.
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
